module.exports = __webpack_public_path__ + "56ac648ebe842fe353a8068b9198166d.pdf";